import React from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';
import WithConfig from 'config/WithConfig';
import UserUtils from 'user/user-utils';
import SpotImagesDesktop from './SpotImagesDesktop';
import ProximityInformation from './ProximityInformation';
import SaveAsFavorite from './SaveAsFavorite';
import AmenitiesListDesktop from './AmenitiesListDesktop';
import ThingsYouShouldKnow from './ThingsYouShouldKnow';

const SpotInfoTabDesktop = ({
    user,
    cloudinary,
    cloudinaryTransformations,
    isMonthly,
    facility,
    selectedRate,
    distance,
    distanceInMiles,
    drivingDuration,
    walkingDuration,
    onSeeLargerImagesClick,
    onShowRateDetailsClick
}) => {
    const {
        parking_spot_id: facilityId,
        title: facilityTitle,
        images: facilityImages,
        amenities_full: facilityAmenities
    } = facility;

    return (
        <div className="SpotInfoTab">
            {facilityImages.length > 0 &&
                <div className="SpotImagesDesktop-container">
                    <SpotImagesDesktop
                        key={facilityId}
                        images={facilityImages}
                        alt={facilityTitle}
                    />
                    <TextButton
                        className="view-larger-images"
                        onClick={onSeeLargerImagesClick}
                    >
                        See Larger Image{facilityImages.length > 1 && 's'}
                    </TextButton>
                </div>
            }
            <div
                className="SpotDetailDetails"
                itemScope
                itemType="http://schema.org/ParkingFacility"
            >
                <h3 className="heading-md title">
                    {(selectedRate.newMonthlyRate)
                        ? selectedRate.title
                        : facilityTitle
                    }
                </h3>
                <ProximityInformation
                    amenities={selectedRate.amenities}
                    distance={distance}
                    distanceInMiles={distanceInMiles}
                    drivingDuration={drivingDuration}
                    walkingDuration={walkingDuration}
                />
                {(user.status === UserUtils.AUTH_STATE.USER) &&
                    <SaveAsFavorite
                        spotId={facilityId}
                    />
                }
                <ThingsYouShouldKnow
                    rate={selectedRate}
                    facility={facility}
                    isMonthly={isMonthly}
                    onShowRateDetailsClick={onShowRateDetailsClick}
                />
                <AmenitiesListDesktop
                    rate={selectedRate}
                    isMonthly={isMonthly}
                    nonRateAmenities={facilityAmenities}
                    onShowRateDetailsClick={onShowRateDetailsClick}
                />
            </div>
        </div>
    );
};

SpotInfoTabDesktop.propTypes = {
    user: PropTypes.object,
    isMonthly: PropTypes.bool,
    cloudinary: PropTypes.object,
    cloudinaryTransformations: PropTypes.func,
    facility: PropTypes.object,
    selectedRate: PropTypes.object,
    distance: PropTypes.number,
    distanceInMiles: PropTypes.string,
    drivingDuration: PropTypes.string,
    walkingDuration: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onSeeLargerImagesClick: PropTypes.func,
    onShowRateDetailsClick: PropTypes.func
};

export default WithConfig(SpotInfoTabDesktop);
